import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { client } from '../../networking/client';
import { RootState } from '../store';
import { toast } from 'react-toastify';

export interface IDoctor {
  person_id: string;
  person_firstname: string;
  person_lastname: string;
  person_tittle: string;
  person_birthdate: Date;
  gender: string;
  person_external_id?: string;
  business_partner_mobile: string;
  business_partner_person_email: string;
  person_appointments: IPersonAppointments[];
  designation: string;
}

interface IPersonAppointments {
  sales_order_id: number;
  work_order_id: number;
  sales_order_item_id: number;
  start: Date | null;
  end_time: Date | null;
}

export interface DoctorsState {
  fetchStatus: string;
  doctors: IDoctor[];
}

const initialState: DoctorsState = {
  fetchStatus: 'idle',
  doctors: [],
};

export const fetchDoctors = createAsyncThunk(
  'doctors/fetchAll',
  async (_, { dispatch, rejectWithValue, getState }) => {
    const state: any = getState();
    try {
      const [doctorsResponse, nutritionistResponse]: any = await Promise.all([
        client.get(`/healthpoint/person-by-location/3/${state?.auth?.locationId}`),
        client.get(`/healthpoint/person-by-location/4/${state?.auth?.locationId}`),
      ]);
      return [doctorsResponse, nutritionistResponse];
    } catch (err: any) {
      return rejectWithValue(err?.response?.data ?? {});
    }
  }
);

export const doctorsSlice = createSlice({
  name: 'doctors',
  initialState,
  reducers: {
    resetDoctors: (_) => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchDoctors.pending, (state) => {
        state.fetchStatus = 'pending';
      })
      .addCase(fetchDoctors.fulfilled, (state, action) => {
        state.doctors = [
          ...action.payload[0].data.personByDesignationInLocation,
          ...action.payload[1].data.personByDesignationInLocation,
        ];
        state.fetchStatus = 'fulfilled';
      })
      .addCase(fetchDoctors.rejected, (state, action: any) => {
        toast.error(action?.payload?.error ?? 'Something went wrong.', {
          position: toast.POSITION.BOTTOM_RIGHT,
        });
        state.fetchStatus = 'rejected';
      });
  },
});

export const { resetDoctors } = doctorsSlice.actions;

export default doctorsSlice.reducer;

export const selectDoctors = (state: RootState) => state.doctors.doctors;
export const selectFetchDoctorsStatus = (state: RootState) => state.doctors.fetchStatus;
